<script setup lang="ts">
/**
 * Error page for `ErrorCode.NoNonceInStorage` — the nonce is missing from
 * `sessionStorage`. This normally means the user closed the tab between the
 * login redirect and the callback (sessionStorage is tab-scoped and does not
 * persist across tab closures). Delegates all rendering to `AuthErrorView`.
 */
import AuthErrorView from '@/components/errors/AuthErrorView.vue'
import { ErrorCode } from '@/errors/codes'
</script>

<template>
  <AuthErrorView :code="ErrorCode.NoNonceInStorage" />
</template>
